<template>
  <div class="overall-bg p-0">
    <b-container class="py-5">
      <b-row>
        <Tableview :value="List" :paginator="false" class="p-datatable-gridlines" :rows="10" dataKey="Id"
          :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll" :columns="headers"
          :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single" @row-click="RowClick">
          <template v-slot:action="{ data }">
            <span>
              <EditIcon @click="Editdata(data)" />
              <DeleteIcon @click="Deletedata(data)" />
            </span>
          </template>
        </Tableview>
      </b-row>
    </b-container>
    <div>
      <createdsuccessfully :visible="successpop" @ok="closetrigger()" />
      <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
      <DeletedSuccessfully :visible="deletepop" @ok="deletepop = false" />
      <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete(dataEdit)" @no="Deletemodel = false" />
      <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit()" @no="Editmodel = false" :content="$t('confirmation.editcontent')" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import BackBtn from "../../../../../components/FormComponents/BacktoMaster.vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import EditConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../components/FormComponents/DeletedSuccessfully.vue";
import createdsuccessfully from "../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../components/FormComponents/AlreadyExist.vue";
import commonservice from "../../../../../modules/Inventory/Service/StoreService";
import { setupHistoryManagement } from "../../../../../modules/Inventory/Service/HistoryManage";

export default defineComponent({
  components: {
    Tableview,
    BackBtn,
    Headerlayout,
    EditConfirmation,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    createdsuccessfully,
    UpdatedSuccessfully,
    AlreadyExist,
  },

  setup() {
    const Storenamelist = ref();
    const Categoryoption = ref();
    const Itemoption = ref();
    const Rackoption = ref();
    const Roomoption = ref();
    const Rowoption = ref();
    const Boxoption = ref();
    const alreadyexistpop = ref(false);
    const successpop = ref(false);
    const updatepop = ref(false);
     const Editmodel = ref(false);
    const { t } = useI18n();
    let loading1 = ref(false);
    const rowFocus = ref(false);
    const dataEdit = ref();

    let mapformdata = ref({
      IsNew: true,
      IsModified: true,
      IsDeleted: true,
      IsActive: true,
      CreatedAt: "2023-03-24T13:45:21.191Z",
      ModifiedAt: "2023-03-24T13:45:21.191Z",
      CreatedBy: 0,
      ModifiedBy: 0,
      CreatedByName: "string",
      Id: 0,
      StoreId: "",
      ItemCategoryId: "",
      ItemId: "",
      RoomId: "",
      RackId: "",
      RowId: "",
      BoxId: "",
      HospitalId: 0,
      BranchId: 0,
      ReOrderLevel: "",
    });

    //Get Storage from session

    function getStorage() {
      const storedData = localStorage.getItem("user");
      const userData = JSON.parse(storedData!);
      const loginStoreId = userData["StoreId"];
      console.log(loginStoreId);
    }

    const headers = [
      {
        header: "File Name",
        field: "",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Category",
        field: "",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Size",
        field: "",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Date Uploaded",
        field: "",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },

      {
        header: "Uploaded by",
        field: "",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        field: "action", header: "Action", slot: "action",
        frozencolumn: true, sortable: false
      },
    ];

    const items = ref([]);

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      StoreName: { value: null, matchMode: FilterMatchMode.IN, options: items },
      CategoryName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      ItemCount: { value: null, matchMode: FilterMatchMode.IN, options: items },
    };

    let List = ref([]);

    const globalFilterFields = ref(headers.map((col) => col.field));

    //TableView
    const routers = useRouter();

    const router = useRoute();

    const storeid = router.query.Id;

    //Load Store Table
    async function IsShow() {
      // debugger;
      // const result = await commonservice.getStoreList();
      // console.log(result);
      // List.value = result["result"];
    }

    function RowClick(event: any) {
      debugger;
      Editmodel.value = true;
      rowFocus.value = true;
      dataEdit.value = event.data;
    }

    //Loading

    let loading = ref(false);

    let strid = 0;

    const deletepop = ref(false);

    const Deletemodel = ref(false);
    let obj = ref({});

    function Editdata(data) {
      console.log(data);
      obj.value = data;
      strid = data.StoreId;
      Editmodel.value = true;
    }

    function Deletedata(data) {
      obj.value = data;
      strid = data.StoreId;
      alert(strid);
      Deletemodel.value = true;
    }

    //Created Sucessfully Popup-Close

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      //routers.back();
      setupHistoryManagement(routers, 2);

    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      //showDialog.value = true
    }

    //IsEdit

    function IsEdit() {
      let data = obj.value;
      mapformdata.value.StoreId = obj.value["StoreId"];
      mapformdata.value.ItemCategoryId = obj.value["CategoryId"];
      mapformdata.value.ItemId = obj.value["ItemId"];

      mapformdata.value.ReOrderLevel = obj.value["ReOrderLevel"];

      Editmodel.value = false;
    }

    //Isdelete

    async function IsDelete(data) {
      const result = await commonservice.deleteStore(data.Id);
      console.log(result);
      let message = result["ErrorInfo"].ErrorCode;
      if (result["result"] != "False" && message == null) {
        Deletemodel.value = false;
        // MappingPop.value.content = result['result'];
        // MappingPop.value.visible = true;
      } else if (message == null) {
        deletepop.value = true;
        Deletemodel.value = false;
        rowFocus.value = false;
        IsShow();
      }
    }

    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
    });

    function onKeyUp(event: any) {
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true &&
        Deletemodel.value == false
      ) {
        Editmodel.value = true;
      } else if (
        event.altKey &&
        event.key == "n" &&
        Editmodel.value == false &&
        Deletemodel.value == false
      ) {
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        IsDelete(dataEdit.value);
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit();
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (
        event.key == "d" &&
        rowFocus.value == true &&
        Editmodel.value == false
      ) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      }
    }

    onMounted(() => {
      IsShow();
    });

    return {
      Storenamelist,
      Categoryoption,
      Itemoption,
      Roomoption,
      Rackoption,
      Rowoption,
      Boxoption,
      mapformdata,
      deletepop,
      alreadyclosetrigger,
      Editdata,
      Deletedata,
      getStorage,
      IsShow,
      IsDelete,
      IsEdit,
      closetrigger,
      headers,
      filters,
      globalFilterFields,
      loading1,
      List,
      Deletemodel,
      Editmodel,
      successpop,
      alreadyexistpop,
      RowClick,
      dataEdit,
    };
  },
  created() { },
});
</script>
